<script setup lang="ts">
import {ref} from 'vue'
import type {CatalogBannerType} from "@/assets/ts/typeCatalogBanner"
import ElementVideo from "@/components/elements/elementVideo.vue";

type bannerType = {
  imageSrc: string
  alt: string
  eyebrow: string
  title: string
}

interface Product {
  set_id: string;
  hash?: string;
  price: number;
  price_gold: number;
  price_platinum: number;
  metal: string;
  stones: string;
  image: {
    filename: string
    filename_layer: string
    positions: {
      filename: string

    }[]
  };
}

const props = withDefaults(
  defineProps<{
    catalogBanners?: CatalogBannerType[];
    item: Product;
    index: number;
  }>(),
  {
    catalogBanners: () => [],
    index: 0,
  }
);

/**
 * Banner
 */

const getNextBanner = (): false | bannerType => {
  if (props?.catalogBanners && props?.catalogBanners?.length > 0) {
    const bannerIdx = Math.floor((props.index - 4) / 8)
    if (props?.catalogBanners?.length > bannerIdx) {
      return props?.catalogBanners?.[bannerIdx] || false
    } else {
      return false
    }
  } else {
    return false
  }
}

const banner = ref<false | bannerType>(getNextBanner())

/**
 * get marketingBoxImage
 */

const getMarketingBoxImage = (item: Product) => {
  const positions: string[] = ["closeup-", "model-", "still-"]
  for (const positionIdx in positions) {
    for (const idx in item.image.positions) {
      const position: string = positions[positionIdx] || "";
      if (item.image.positions[idx]?.filename.includes(position)) {
        return item.image?.positions[idx]?.filename
      }
    }
  }
  return ""
}

const fallbackMarketingImage = "https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/ru-6011/closeup/closeup-ru-6011_white.female.f2ba346d-e6ee-4e97.mp4"

const marketingImage = ref<string>(getMarketingBoxImage(props.item) || fallbackMarketingImage)

const onMarketingImageError = () => {
  if (marketingImage.value !== fallbackMarketingImage) {
    marketingImage.value = fallbackMarketingImage
  }
}
</script>

<template>
  <article class="relative overflow-hidden sm:col-span-2 lg:col-span-2 group object-cover h-full w-full">
    <template v-if="banner !== false">
      <img
          :src="banner?.imageSrc"
          :alt="banner?.alt"
          class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"/>
      <div
          class="absolute bottom-10 left-0 right-0 text-white w-full flex flex-col items-center justify-between transition-transform duration-500 group-hover:translate-y-[-10px]">
        <div class="max-w-3/5 flex flex-col items-center justify-between text-center">
          <p class="text-base tracking-wide mb-4">{{ banner?.eyebrow }}</p>
          <h3 class="mt-2 text-3xl">{{ banner?.title }}</h3>
        </div>
      </div>
    </template>
    <template v-else>
      <element-video
          v-if="marketingImage.endsWith('.mp4')"
          :src=marketingImage
          video-class="object-cover mx-auto w-full h-full relative z-30"
          @error="onMarketingImageError"
      />
      <template v-else>
        <img
            :src="marketingImage"
            :alt="item.set_id"
            :title="item.set_id"
            class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            @error="onMarketingImageError"
        >
      </template>
    </template>
  </article>


</template>

<style scoped>

</style>